import React, { createContext, useState, useEffect, useContext } from 'react';
import { jwtDecode } from 'jwt-decode'; // Para decodificar el token

// 1. Crear el Contexto
const AuthContext = createContext(null);

// 2. Crear el Proveedor del Contexto
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // Almacena la información del usuario (id, username, role)
    const [token, setToken] = useState(null); // Almacena el token JWT
    const [isAuthenticated, setIsAuthenticated] = useState(false); // Estado booleano de autenticación
    const [loading, setLoading] = useState(true); // Para manejar el estado de carga inicial

    // Función para verificar el token al cargar la aplicación o al refrescar
    useEffect(() => {
        const loadUserFromStorage = () => {
            try {
                const storedToken = localStorage.getItem('token');
                if (storedToken) {
                    const decodedToken = jwtDecode(storedToken);
                    // Comprobar si el token ha expirado
                    // exp es en segundos, Date.now() es en milisegundos
                    if (decodedToken.exp * 1000 < Date.now()) {
                        console.log('Token expirado. Eliminando...');
                        localStorage.removeItem('token');
                        localStorage.removeItem('user');
                        setToken(null);
                        setUser(null);
                        setIsAuthenticated(false);
                    } else {
                        const storedUser = JSON.parse(localStorage.getItem('user'));
                        setToken(storedToken);
                        setUser(storedUser);
                        setIsAuthenticated(true);
                    }
                }
            } catch (error) {
                console.error('Error al cargar el usuario del almacenamiento o decodificar el token:', error);
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                setToken(null);
                setUser(null);
                setIsAuthenticated(false);
            } finally {
                setLoading(false); // Finaliza la carga inicial
            }
        };

        loadUserFromStorage();
    }, []); // Se ejecuta solo una vez al montar el componente

    // Función de login
    const login = (newToken, newUser) => {
        localStorage.setItem('token', newToken);
        localStorage.setItem('user', JSON.stringify(newUser));
        setToken(newToken);
        setUser(newUser);
        setIsAuthenticated(true);
    };

    // Función de logout
    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setToken(null);
        setUser(null);
        setIsAuthenticated(false);
    };

    // El valor que se proporcionará a los componentes consumidores
    const authContextValue = {
        user,
        token,
        isAuthenticated,
        loading,
        login,
        logout,
    };

    if (loading) {
        return <div>Cargando autenticación...</div>; // O un spinner de carga
    }

    return (
        <AuthContext.Provider value={authContextValue}>
            {children}
        </AuthContext.Provider>
    );
};

// 3. Crear un Hook personalizado para consumir el contexto fácilmente
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth debe ser usado dentro de un AuthProvider');
    }
    return context;
};
